import { SplineSceneController } from '../lib/SplineSceneController';

export function initServiceHero() {
  const parent = document.querySelector('.js-service-hero');
  if (!parent) return;

  const canvas = parent.querySelector('.service-hero__graphics canvas');
  if (!canvas) return;

  const sceneURL = canvas.dataset.splineUrl;
  if (!sceneURL) return;

  const graphics = parent.querySelector('.service-hero__graphics');
  const poster = parent.querySelector('.service-hero__poster');
  const scene = new SplineSceneController({
    canvas,
    parent: graphics,
    poster,
    sceneURL,
    useFirstLoadDelays: true,
    takeScreenshot: false,
  });
  scene.init().then();
}
